const PAYER = {
    BASE_URL: 'https://payeronline.ru',
    BASE_PATH: '/api/v1/',
    SESSION_KEY: 'x}Voa}ENxm|GZKacot05yZ4hmpnab48#8omEc~m1Z0ZTBk}R'
}

export {
    PAYER
}
